export function isSupported(): { supported: boolean; message: string } {
  if (!("serviceWorker" in navigator)) {
    return {
      supported: false,
      message: "Service Worker is not supported in this browser",
    };
  }

  if (window.location.host === "localhost:5173") {
    return {
      supported: false,
      message: "Service Worker is not supported in localhost:5173",
    };
  }

  return {
    supported: true,
    message: "Service Worker is supported",
  };
}
